import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'
import { isoDate } from '../expenses-by-category/iso-date'

const MAX_RANGE_MONTHS = 36

const monthsBetween = (fromIso: string, toIso: string): number => {
  const from = new Date(`${fromIso}T00:00:00Z`)
  const to = new Date(`${toIso}T00:00:00Z`)
  return (
    (to.getUTCFullYear() - from.getUTCFullYear()) * 12 + (to.getUTCMonth() - from.getUTCMonth()) + 1
  )
}

export const incomesByCategoryQuerySchema = z
  .object({
    from: isoDate,
    to: isoDate,
    baseCurrency: z.nativeEnum(Currency).optional(),
  })
  .refine((q) => q.from <= q.to, { message: 'from must be on or before to', path: ['from'] })
  .refine((q) => monthsBetween(q.from, q.to) <= MAX_RANGE_MONTHS, {
    message: `range must not exceed ${MAX_RANGE_MONTHS} months`,
    path: ['to'],
  })

export type IncomesByCategoryQueryDto = z.infer<typeof incomesByCategoryQuerySchema>

export const INCOMES_BY_CATEGORY_MAX_RANGE_MONTHS = MAX_RANGE_MONTHS
